
import React from 'react';
import MainLayout from '@/components/layouts/MainLayout';

export default function EditReportLoadingState() {
  return (
    <MainLayout allowedRoles={['admin']}>
      <div className="flex justify-center items-center h-full">
        <p>Loading royalty report...</p>
      </div>
    </MainLayout>
  );
}
